import { GenericTableColumnHeader } from '@/libraries/design/patterns/table/src/generic-table-column-header';

export interface UniformTableColumnHeaderProps {
	text: string;
}

const UniformTableColumnHeader = ({ text }: UniformTableColumnHeaderProps) => {
	return <GenericTableColumnHeader>{text}</GenericTableColumnHeader>;
};

export default UniformTableColumnHeader;
